/* Noorns: engagement events for the Shopify-hosted explainer video (2026-10-13).
   Used by the homepage video band (sections/noorns-home.liquid) and the watch page when it
   plays a Shopify-hosted file (sections/noorns-watch.liquid).

   What it does: for every element with data-video-track that holds a <video>, it publishes
   Shopify customer events from the theme. A custom pixel (repo:
   projects/noorns/site-redesign/implementation/pixels/video-engagement-pixel.js) subscribes to
   them and sends them on to GA4. Without that pixel connected, nothing leaves the page.

   Theme to pixel route: Shopify.analytics.publish(name, data) in theme code, and
   analytics.subscribe(name, e => e.customData) in the pixel.
     https://help.shopify.com/en/manual/promoting-marketing/pixels/custom-pixels/code (read 2026-10-13,
       "Subscribe to custom customer events")
     https://shopify.dev/docs/api/web-pixels-api/emitting-data (read 2026-10-13)
   Event names and parameters follow GA4's video engagement events (video_start, video_progress at
   set percents, video_complete; video_current_time, video_duration, video_percent, video_provider,
   video_title, video_url): https://support.google.com/analytics/answer/9216061 (read 2026-10-13).
   Button clicks use GA4's recommended select_content (content_type, content_id):
     https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#select_content
     (read 2026-10-13).

   Rules: video_start once per page view (first time it plays), video_progress at 25, 50 and 75 percent,
   each once per page view (a jump past a mark counts the marks it passed), video_complete once.
   Consent is not handled here: the theme only publishes; Shopify runs the pixel only with the
   visitor's permission (custom pixel Customer privacy settings).

   Custom event names carry a "noorns:" prefix so they can't collide with Shopify's standard
   events or another app's. window.__noornsVideoEvents keeps a copy for checks. */
(function () {
  var MARKS = [25, 50, 75];
  window.__noornsVideoEvents = window.__noornsVideoEvents || [];

  // Every key any event can carry. Each dataLayer push names all of them (absent ones as undefined),
  // because Tag Manager keeps values from earlier pushes: without this, a select_content push would
  // carry the video_percent of the last progress event.
  var KEYS = ['video_title', 'video_id', 'video_location', 'video_provider', 'video_url',
              'video_duration', 'video_current_time', 'video_percent',
              'content_type', 'content_id', 'link_url', 'link_text'];

  // Added 2026-10-21: the same events go to the page's dataLayer as event "noorns_video", with the
  // GA4 event name in noorns_ga4_event. A GA4 Event tag in Tag Manager (GTM-PFHJZB4Z) sends them
  // through the store's own Google tag (G-FH1X5KD2GC, loaded in the page by the Google & YouTube
  // app), so they join the visitor's session. This replaces the custom pixel, whose sandbox
  // created a second, empty GA4 session per visit (projects/noorns/ga4-setup/tracking-check-2026-10-21.md).
  // Tag Manager custom events: https://developers.google.com/tag-platform/tag-manager/datalayer (read 2026-10-21).
  function toDataLayer(name, data) {
    var push = { event: 'noorns_video', noorns_ga4_event: name.replace(/^noorns:/, '') };
    KEYS.forEach(function (k) { push[k] = data[k] === undefined ? undefined : data[k]; });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(push);
  }

  function publish(name, data) {
    window.__noornsVideoEvents.push({ name: name, data: data });
    try { toDataLayer(name, data); } catch (e) { /* tracking never breaks the page */ }
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* tracking never breaks the page */ }
  }

  function base(box, v) {
    var src = (v.currentSrc || '').split('?')[0];
    return {
      video_title: box.getAttribute('data-video-title') || '',
      video_id: box.getAttribute('data-video-id') || '',
      video_location: box.getAttribute('data-video-location') || '',
      video_provider: 'shopify',
      video_url: src,
      video_duration: Math.round(v.duration || 0),
      video_current_time: Math.round(v.currentTime || 0)
    };
  }

  function track(box) {
    var v = box.querySelector('video');
    if (!v || box.__noornsTracked) return;
    box.__noornsTracked = true;
    var started = false, done = false, sent = {};

    // 'playing', not 'play': with preload none the length isn't known until the file starts,
    // and 'playing' fires once it has, so video_start carries the real duration.
    v.addEventListener('playing', function () {
      if (started) return;
      started = true;
      var d = base(box, v); d.video_percent = 0;
      publish('noorns:video_start', d);
    });
    v.addEventListener('timeupdate', function () {
      if (!started || !v.duration) return;
      var pct = (v.currentTime / v.duration) * 100;
      MARKS.forEach(function (m) {
        if (pct >= m && !sent[m]) {
          sent[m] = true;
          var d = base(box, v); d.video_percent = m;
          publish('noorns:video_progress', d);
        }
      });
    });
    v.addEventListener('ended', function () {
      if (done) return;
      done = true;
      var d = base(box, v); d.video_percent = 100;
      publish('noorns:video_complete', d);
    });
  }

  function clicks() {
    document.querySelectorAll('[data-video-cta]').forEach(function (a) {
      if (a.__noornsTracked) return;
      a.__noornsTracked = true;
      a.addEventListener('click', function () {
        publish('noorns:select_content', {
          content_type: 'video_band_button',
          content_id: a.getAttribute('data-video-cta'),
          link_url: a.origin + a.pathname + a.hash,  // without query strings other scripts add to links
          link_text: (a.textContent || '').trim(),
          video_title: a.getAttribute('data-video-title') || '',
          video_location: a.getAttribute('data-video-location') || ''
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-video-track]').forEach(track);
    clicks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
